import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const MainContainer = superstyled(
  {
    name: 'Maincontainer',
    slot: 'Maincontainer',
    tag: Grid,
    styles: ({ theme }) => ({
      borderRadius: 24,
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr)',
      gridRowGap: '1.5rem',
      gridColumnGap: '5%',
      padding: '24px 0',
      [theme.breakpoints.up('sm')]: {
        background: 'radial-gradient(95.58% 165.4% at 74.32% 28.67%, rgba(255, 255, 255, 0.2) 0%, rgba(75, 73, 75, 0) 100%), #1C1C1C',
        gridTemplateColumns: '2fr 1.5fr',
        gridRowGap: '1rem',
        padding: '60px 80px'
      },
      [theme.breakpoints.up('md')]: {
        padding: '60px 80px 0 80px'
      }
    })
  }
);

export const MarkCubanImageContainer = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    display: 'grid',
    alignItems: 'flex-end',
    justifyItems: 'center',
    [theme.breakpoints.down('sm')]: {
      background: 'radial-gradient(95.58% 165.4% at 74.32% 28.67%, rgba(255, 255, 255, 0.2) 0%, rgba(75, 73, 75, 0) 100%), #1C1C1C',
      borderRadius: 24,
      marginTop: '1.5rem',
      padding: '32px 32px 0 32px'
    }
  })
});

export const Heading = superstyled({
  tag: Title,
  name: 'Heading',
  slot: 'Heading',
  styles: ({ theme }) => ({
    marginTop: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      color: `${theme.palette.focus00.light} !important`
    }
  })
});

export const SubHeading = superstyled({
  tag: Text,
  styles: ({ theme }) => ({
    marginTop: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      color: `${theme.palette.focus00.light} !important`
    }
  })
});
export const MarkCubanImage = superstyled({
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '75%',
    maxWidth: '28rem',
    [theme.breakpoints.up('md')]: {
      width: '100%'
    }
  })
});

export const TextsContainer = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px'
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: '60px'
    }
  })
});
